<template>
  <vSelect
    class="user-select-shop__select user-select-shop__select--select"
    :placeholder="$t('start_tap_to_search')"
    label="address"
    :options="shopsInSelect"
    :value="computedManagerStore"
    @search="handleSearch"
    @input="sendShop"
    @click.native="handleEmptySearch"
    :clearable="false"
    :disabled="!this.selectedUserLocation.city_id"
  >
    <span slot="no-options">{{ emptyError }}</span>
  </vSelect>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import { debounce } from '@/mixins'
import axios from 'axios'

export default {
  name: 'UserSelectShop',
  mixins: [debounce],
  components: {
    vSelect
  },
  data () {
    return {
      searchValue: '',
      shopsInSelect: [],
      selectedStore: null
    }
  },
  props: {
    isChangeUserType: Boolean
  },
  computed: {
    ...mapState({
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      managerStore: state => state.checkout.managerStore,
      managerStoreUid: state => state.checkout.managerStoreUid
    }),

    ...mapGetters(['urlLanguagePrefix']),
    emptyError () {
      return this.searchValue.length < 1
        ? this.$t('enter_3_characters_geo')
        : this.$t('not_found_geo')
    },
    computedManagerStore () {
      if (
        this.managerStoreUid &&
        this.managerStore?.uid === this.managerStoreUid &&
        this.managerStore?.city.id === this.selectedUserLocation.city_id
      ) {
        return this.managerStore
      }

      return this.selectedStore
    },
    resetDataForSelect () {
      return {
        address: this.$t('reset_data_for_select_store'),
        uid: null
      }
    }
  },
  methods: {
    ...mapActions(['SET_MANAGER_STORE_ACTION']),
    handleSearch (value) {
      this.searchValue = value
      if (!value) {
        this.shopsInSelect = [this.resetDataForSelect]
        return
      }
      this.debounce(() => {
        axios
          .get(this.urlLanguagePrefix + '/manager-checkout/get-stores/', {
            params: { city_id: this.selectedUserLocation.city_id, extended: true, q: value }
          })
          .then(response => {
            if (this.searchValue) this.shopsInSelect = [this.resetDataForSelect, ...response.data.data]
          })
      }, 300)
    },
    handleEmptySearch (e) {
      this.handleSearch(' ')
    },
    sendShop (store) {
      if (store) {
        this.selectedStore = store
        localStorage.setItem('managerSelectedStore', JSON.stringify(store))
        this.SET_MANAGER_STORE_ACTION(store).then(() => {
          if (!this.isChangeUserType) this.$modal.hide('user-type-modal')
        })
      }
    }
  }
}
</script>

<style lang="sass">

@import '~@/styles/blocks/checkout-form/libraries-elements'

.user-select-shop__select
  position: relative
  width: 100%
  color: $text-color

  +mmin($small)
    max-width: 540px

  .vs__search
    padding: 5px 14px
    font-size: 14px

    &::placeholder
      color: $placeholder-color

  .vs__dropdown-menu
    box-shadow: 0 2px 10px rgba(51, 51, 51, 0.25)
    border: 0
    max-height: 200px

    li
      font-size: 14px!important

  .vs__dropdown-option
    padding: 9px 16px
    font-size: 14px

    &--highlight
      background: $nd-disabled-background-color
      color: $text-color

  .vs__selected
    display: block
    width: 90%
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    margin: 7px 9px 0

  .vs__dropdown-toggle
    height: 40px

.user-select-shop__select:not(.user-select-shop__select--select)
  .vs__actions
    display: none
</style>
